import 'reflect-metadata';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

import { initGa } from '@/common/helpers/init-ga';
import '@/css/colors.css';
import '@/css/default.theme.css';
import '@/css/fonts.css';
import '@/css/smart-banner.css';
import '@/css/tailwind.css';
import '@/css/theme.eca.css';
import { i18n } from '@/locales';
import 'mapbox-gl/dist/mapbox-gl.css';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const app = createApp(App);

app.use(i18n);
app.use(router);
app.use(pinia);
initGa(router);

app.mount('#app');
